<template>
  <div>
    <v-card-actions>
      <v-row>
        <v-col>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                outlined
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>{{ icons.mdiMenu }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="showTranfRoom()">
                <v-list-item-title>Transferir Quarto</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showTranfItens()">
                <v-list-item-title>Transferir Itens</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showTranfDiarias()">
                <v-list-item-title>Transferir Diárias</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showEditCheckout()">
                <v-list-item-title>Editar Diárias</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showExtraDialog()">
                <v-list-item-title>Tarifas Extraordinárias</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showDialogConsumption()">
                <v-list-item-title>Consumo Hóspede</v-list-item-title>
              </v-list-item>
              <v-list-item @click="showInternalNotes()">
                <v-list-item-title>Notas Internas</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <!-- <v-btn x-large color="secondary" @click="showTranfRoom()" class="mr-4">Transferir Quarto</v-btn>
                <v-btn x-large color="secondary" @click="showEditCheckout()" class="mr-4">Checkout</v-btn> -->
        </v-col>
        <!-- <v-col class="text-right">
                <v-btn class="mr-4" x-large text @click="dialogRoom=false">Fechar</v-btn>
                <v-btn color="primary" x-large :loading="editedItemLoading" @click="save()">Salvar</v-btn>
            </v-col> -->
      </v-row>
    </v-card-actions>
    <v-card-text class="mt-4">
      <v-row>
        <v-col cols="8">
          <v-tabs
            v-model="tab"
            background-color="secondary"
            outlined
          >
            <v-tab>Produtos</v-tab>
            <v-tab>Serviços</v-tab>
            <v-tab>Hóspedes</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- TABELA PRODUTOS  -->
            <v-tab-item>
              <v-card outlined>
                <v-data-table
                  :headers="headers"
                  disable-sort
                  :items="itemsProducts"
                  sort-by="calories"
                  class="elevation-0"
                  :footer-props="{
                    itemsPerPageText: 'Itens por pagina',
                    itemsPerPageOptions: [5],
                    showFirstLastPage: true,
                  }"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Produtos</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <!-- <v-spacer></v-spacer> -->
                      <autocomplete-search-product
                        v-model="product"
                        :dense="true"
                        class="mt-7"
                      />
                      <v-btn
                        class="ml-2"
                        color="primary"
                        :disabled="!product"
                        @click="dialogQtyProduct()"
                      >
                        <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar
                      </v-btn>
                      <v-btn
                        color="secondary"
                        :loading="loadingPrintProduct"
                        :disabled="loadingPrintProduct"
                        class="ml-2 hide-print-orders"
                        @click="sendPrintProduct()"
                      >
                        Imprimir Pedidos
                      </v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.print="{ item }">
                    <v-btn
                      v-if="hasPrinters"
                      icon
                      color="secondary"
                      :loading="loadingPrintProduct"
                      @click="reprintProduct(item)"
                    >
                      <v-icon>{{ icons.mdiPrinter }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      icon
                      large
                      color="error"
                      @click="dialogRemoveProduct(item)"
                    >
                      <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ formatMoney(calcTotalProduct(item)) }}
                  </template>
                  <template v-slot:item.pdv="{ item }">
                    {{ pdvDescription(item.pivot.pdv_id) }}
                  </template>
                  <template v-slot:item.qty="{ item }">
                    {{ formatMoney(item.pivot.quantity) }}
                  </template>
                  <template v-slot:item.sale_price="{ item }">
                    {{ formatMoney(item.sale_price) }}
                  </template>
                  <template v-slot:foot="{ item }">
                    <tr
                      style="height:44px; background:#fafafa"
                      class=""
                    >
                      <td
                        colspan="3"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
                      >
                        <b>TOTAL:</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6 ;padding-left:16px;padding-right:16px"
                      >
                        <b>{{ formatMoney(calcTotalProductAmount) }}</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <!-- TABELA SERVIÇOS -->
            <v-tab-item>
              <v-card outlined>
                <v-data-table
                  :headers="headers_service"
                  :items="services"
                  disable-sort
                  class="elevation-0"
                  :footer-props="{
                    itemsPerPageText: 'Itens por pagina',
                    itemsPerPageOptions: [5],
                    showFirstLastPage: true,
                  }"
                >
                  <template v-slot:top>
                    <v-toolbar flat>
                      <v-toolbar-title>Serviços</v-toolbar-title>
                      <v-divider
                        class="mx-4"
                        inset
                        vertical
                      ></v-divider>
                      <!-- <v-spacer></v-spacer> -->
                      <AutocompleteSearchService
                        v-model="service"
                        :dense="true"
                        class=""
                      ></AutocompleteSearchService>
                      <v-btn
                        class="ml-2"
                        color="primary"
                        :disabled="!service"
                        @click="showDialogQtyService()"
                      >
                        <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar
                      </v-btn>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn
                      icon
                      large
                      color="error"
                      @click="dialogRemoveService(item)"
                    >
                      <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:item.total="{ item }">
                    {{ formatMoney(calcTotalService(item)) }}
                  </template>
                  <template v-slot:item.qty="{ item }">
                    {{ formatMoney(item.pivot.quantity) }}
                  </template>
                  <template v-slot:item.sale_price="{ item }">
                    {{ formatMoney(item.sale_price) }}
                  </template>
                  <template v-slot:foot="{ item }">
                    <tr
                      style="height:44px; background:#fafafa"
                      class=""
                    >
                      <td
                        colspan="2"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6;padding-left:16px;padding-right:16px"
                      >
                        <b>TOTAL:</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6 ;padding-left:16px;padding-right:16px"
                      >
                        <b>{{ formatMoney(calcTotalServiceAmount) }}</b>
                      </td>
                      <td
                        class="text-right"
                        style="border-top:solid 1px #e4e3e6"
                      ></td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <!-- TABELA HOSPEDES -->
            <v-tab-item>
              <v-card outlined>
                <TableGuestBusy
                  :guests="guests"
                  @updateGuests="updateGuest"
                ></TableGuestBusy>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
        <v-col cols="4">
          <v-card
            elevation="0"
            outlined
            style="height:453px"
          >
            <v-card-text>
              <h3>Dados da conta</h3>
              <v-row>
                <v-col>
                  <v-row no-gutters>
                    <v-col>Reserva ID:</v-col>
                    <v-col class="text-right">
                      {{ room.current_reserve_id }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Comanda ID:</v-col>
                    <v-col class="text-right">
                      {{ room.current_accommodation_id }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Veículo placa:</v-col>
                    <v-col class="text-right">
                      {{ licensePlate }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Origem:</v-col>
                    <v-col class="text-right">
                      {{ (room.current_accommodation.company ?
                        room.current_accommodation.company.fantasy_name : '*****').substring(0, 20) }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <h3 class="mt-6">
                Dados da conta
              </h3>
              <v-row>
                <v-col>
                  <v-row no-gutters>
                    <v-col>Valor quarto:</v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>Valor Consumo:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Impostos:</v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      R$ {{ formatMoney(room.totalRoomCurrent) }}
                    </v-col>
                  </v-row>
                  <v-row
                    class="text-right"
                    no-gutters
                  >
                    <v-col> R$ {{ formatMoney(room.consumption) }}</v-col>
                  </v-row>
                  <v-row
                    class="text-right"
                    no-gutters
                  >
                    <v-col> R$ {{ formatMoney(getTaxation) }}</v-col>
                  </v-row>
                </v-col>
              </v-row>

              <h3 class="mt-6">
                Resumo da estadia
              </h3>
              <v-row>
                <v-col>
                  <v-row no-gutters>
                    <v-col>Entrada:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Saída Limite:</v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col>Permanência:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Permanência em horas:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Desconto:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>Outros acréscimos:</v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col><b>Total da conta:</b></v-col>
                  </v-row>
                </v-col>

                <v-col>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ formatDateTime(room.current_accommodation.date_checkin) }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ formatDateTime(room.prev_checkout) }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ room.current_accommodation.permanence }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      {{ room.current_accommodation.permanence_hours }}
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      R$ 0,00
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col class="text-right">
                      R$ 0,00
                    </v-col>
                  </v-row>
                  <v-row
                    class="text-right"
                    no-gutters
                  >
                    <v-col> <b> R$ {{ formatMoney(getTotalToPay) }}</b></v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card
            class="my-2"
            elevation="0"
            outlined
          >
            <v-card-text>
              <h3 class="mb-2">
                Observações:
              </h3>
              <v-row>
                <v-col>
                  <span v-text="roomObs"></span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- DIALOG ADICIONAR PRODUTO -->
      <v-dialog
        v-model="dialogQty"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogQty = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <!-- <v-text-field label="Quantidade" v-model="qtyProduct" outlined></v-text-field> -->
                <vuetify-money
                  v-model="qtyProduct"
                  :error-messages="errorQtyProduct"
                  class=""
                  outlined
                  label="Quantidade"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyProduct()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyProduct()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="col-8">
                <SelectPdv v-model="pdv"></SelectPdv>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogQty = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingAddProduct"
                  :disabled="(loadingAddProduct && btnAddQtyProduct)"
                  x-large
                  @click="addProduct()"
                >
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- REMOVER PRODUCT -->
      <v-dialog
        v-model="dialogRemoveQty"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogRemoveQty = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              class="mb-8"
            >
              <v-col>
                <h3>Quantidade: {{ formatMoney(qtyCurrentProduct) }}</h3>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <vuetify-money
                  v-model="qtyRemoveProduct"
                  :error-messages="errorQtyRemoveProduct"
                  class=""
                  outlined
                  label="Quantidade Retirada"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyRemoveProduct()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyRemoveProduct()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="obsRemoveProduct"
                  :error-messages="errorObsRemoveProduct"
                  rows="2"
                  outlined
                  label="Observação"
                  required
                  @input="errorObsRemoveProduct = null"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogRemoveQty = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="error"
                  :loading="loadingRemovedProduct"
                  :disabled="btnQtyRemoveProduct"
                  x-large
                  @click="removeProduct()"
                >
                  remover
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG ADICIONAR SERVIÇO -->
      <v-dialog
        v-model="dialogQtyService"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogQtyService = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <vuetify-money
                  v-model="qtyService"
                  :error-messages="errorQtyService"
                  class=""
                  outlined
                  label="Quantidade"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyService()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyService()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogQtyService = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="btnAddQtyProduct"
                  x-large
                  @click="addService()"
                >
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG REMOVE SERVIÇO -->
      <v-dialog
        v-model="dialogRemoveQtyService"
        width="500"
      >
        <v-card>
          <BarTitleDialog
            title="quantidade"
            @close="dialogRemoveQtyService = false"
          />
          <v-card-text>
            <v-row
              no-gutters
              class="mb-8"
            >
              <v-col>
                <h3>Quantidade: {{ formatMoney(qtyCurrentService) }}</h3>
              </v-col>
            </v-row>

            <v-row
              no-gutters
              style="height:90px"
            >
              <v-col cols="8">
                <vuetify-money
                  v-model="qtyRemoveService"
                  :error-messages="errorQtyRemoveService"
                  class=""
                  outlined
                  label="Quantidade Retirada"
                />
              </v-col>
              <v-col class="text-center">
                <v-btn
                  fab
                  color="secondary"
                  class="mr-2 ml-2"
                  @click="minusQtyRemoveService()"
                >
                  <v-icon>{{ icons.mdiMinus }}</v-icon>
                </v-btn>
                <v-btn
                  fab
                  color="primary"
                  @click="addQtyRemoveService()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="obsRemoveService"
                  :error-messages="errorObsRemoveService"
                  rows="2"
                  outlined
                  label="Observação"
                  required
                  @input="errorObsRemoveService = null"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogRemoveQtyService = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="error"
                  :loading="loadingRemovedService"
                  :disabled="btnQtyRemoveService"
                  x-large
                  @click="removeService()"
                >
                  remover
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG TRANSFERENCIA DE QUARTO -->
      <v-dialog
        v-model="dialogTranfRoom"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Transferir Quarto"
            @close="dialogTranfRoom = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row>
              <v-col>
                <SelectRoom
                  v-model="roomId"
                  :errors="errorRoomTransf"
                  @change="errorRoomTransf = null"
                ></SelectRoom>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogTranfRoom = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransfRoom()"
                >
                  Transferir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG TRANSFERENCIA DE ITENS -->
      <v-dialog
        v-model="dialogTranfItens"
        width="800"
      >
        <v-card>
          <BarTitleDialog
            title="Transferir Itens"
            @close="dialogTranfItens = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              class="mr-4"
              no-gutters
              align="center"
            >
              <v-col>
                <h4><b>Selecione os Itens:</b></h4>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  outlined
                  color="primary"
                  @click="toggleSelectAll"
                >
                  <v-icon
                    small
                    left
                  >
                    {{ allItemsSelected ? icons.mdiCheckboxMarked : icons.mdiCheckboxBlankOutline }}
                  </v-icon>
                  {{ allItemsSelected ? 'Desmarcar Todos' : 'Marcar Todos' }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-card
                  outlined
                  class="mt-2"
                  style="max-height: 300px; overflow-y: auto;"
                >
                  <v-list
                    v-if="transItens.length > 0"
                    dense
                  >
                    <v-list-item
                      v-for="item in transItens"
                      :key="item.id"
                      class="px-2"
                    >
                      <v-list-item-action class="mr-2">
                        <v-checkbox
                          v-model="item.checked"
                          color="primary"
                          hide-details
                          @change="addItemToSend(item)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <b style="color:#16b1ff;">{{ item.description }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="flex-row align-center">
                        <span class="mr-2">{{ item.pivot.quantity }}x</span>
                        <span class="font-weight-bold">R$ {{ formatMoney(item.sale_price) }}</span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-card-text
                    v-else
                    class="text-center grey--text"
                  >
                    Nenhum item disponível para transferir
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <SelectRoomOccupied
                  v-model="roomId"
                  :errors="errorRoomTransf"
                  @change="errorRoomTransf = null"
                >
                </SelectRoomOccupied>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="transfJustification"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="2"
                  label="Justificativa"
                  @input="errorTransfJustification = null"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row
              v-if="admRole.authorization "
              no-gutters
            >
              <v-col>
                <v-select
                  v-model="cashId"
                  outlined
                  label="Caixa"
                  :items="cashItems"
                  item-value="id"
                  item-text="text"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogTranfItens = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransItens()"
                >
                  Transferir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG TRANSFERENCIA DE DIÁRIAS -->
      <v-dialog
        v-model="dialogTranfDiarias"
        width="800"
      >
        <v-card>
          <BarTitleDialog
            title="Transferir Diárias"
            @close="dialogTranfDiarias = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              class="mr-4"
              no-gutters
              align="center"
            >
              <v-col>
                <h4><b>Selecione as Diárias:</b></h4>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  small
                  outlined
                  color="primary"
                  @click="toggleSelectAllDiarias"
                >
                  <v-icon
                    small
                    left
                  >
                    {{ allDiariasSelected ? icons.mdiCheckboxMarked : icons.mdiCheckboxBlankOutline }}
                  </v-icon>
                  {{ allDiariasSelected ? 'Desmarcar Todas' : 'Marcar Todas' }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-card
                  outlined
                  class="mt-2"
                  style="max-height: 300px; overflow-y: auto;"
                >
                  <v-list
                    v-if="transDiarias.length > 0"
                    dense
                  >
                    <v-list-item
                      v-for="item in transDiarias"
                      :key="item.id"
                      class="px-2"
                    >
                      <v-list-item-action class="mr-2">
                        <v-checkbox
                          v-model="item.checked"
                          color="primary"
                          hide-details
                          @change="addDiariaToSend(item)"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          <b style="color:#16b1ff;">{{ formatDate(item.date_start) }} - {{ formatDate(item.date_end) }}</b>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="flex-row align-center">
                        <span class="font-weight-bold">R$ {{ formatMoney(item.value) }}</span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <v-card-text
                    v-else
                    class="text-center grey--text"
                  >
                    Nenhuma diária disponível para transferir
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <SelectRoomOccupied
                  v-model="roomId"
                  :errors="errorRoomTransf"
                  @change="errorRoomTransf = null"
                >
                </SelectRoomOccupied>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="transfJustification"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="2"
                  label="Justificativa"
                  @input="errorTransfJustification = null"
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row
              v-if="admRole.authorization "
              no-gutters
            >
              <v-col>
                <v-select
                  v-model="cashId"
                  outlined
                  label="Caixa"
                  :items="cashItems"
                  item-value="id"
                  item-text="text"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogTranfDiarias = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="sendTransDiarias()"
                >
                  Transferir
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG EDITAR CHECKOUT e CHECKOUT -->
      <v-dialog
        v-model="dialogEditCheckout"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Editar Checkout"
            @close="dialogEditCheckout = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              v-for="item in accommodation_items"
              :key="index"
              no-gutters
              class="mb-2"
            >
              <v-col>
                <vuetify-money
                  v-model="item.value"
                  :option="{ prefix: 'R$' }"
                  dense
                  outlined
                  hide-details
                  :disabled="item.hotel_day_id != null"
                ></vuetify-money>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="item.date_start"
                  hide-details=""
                  type="datetime-local"
                  :readonly="IfOneItem || item.hotel_day_id != null"
                  class="ml-2"
                  outlined
                  dense
                  label="Data Inicio"
                  :disabled="item.hotel_day_id != null"
                  @blur="changeAccomodation()"
                ></v-text-field>
                <!-- <input-date css="ml-2" v-model="tariff.date_start" :label="'Data Inicial'" :dense="true"></input-date> -->
              </v-col>
              <v-col>
                <v-text-field
                  hide-details=""
                  type="datetime-local"
                  readonly
                  class="ml-2"
                  outlined
                  dense
                  :value="item.date_end"
                  label="Data Fim"
                  :disabled="item.hotel_day_id != null"
                ></v-text-field>
                <!-- <input-date css="ml-2" v-model="tariff.date_end" :label="'Data Final'" :dense="true"></input-date> -->
              </v-col>
              <!-- <v-col cols="1"> -->
              <!-- <v-btn icon color="error" class="ml-2" @click="removeTariffExtraordinary(tariff)" >
                                <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                            </v-btn> -->
              <!-- </v-col> -->
            </v-row>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  color="primary"
                  class="ml-2"
                  @click="addAccommodationItem()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar Diária
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  color="error"
                  class="ml-2"
                  @click="removeAccommodationItem()"
                >
                  <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>Remover Diária
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :headers="headers_observation"
              :items="accommodation_observations"
              class="elevation-1"
              dense
              hide-default-header
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  dense
                >
                  <v-toolbar-title>Notas internas</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-btn
                    icon
                    large
                    color="primary"
                    aria-label="Adicionar nota interna"
                    @click="showDialogObsCheckout()"
                  >
                    <v-icon>{{ icons.mdiPlus }}</v-icon>
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  icon
                  large
                  color="error"
                  aria-label="Excluir nota interna"
                  @click="removeObservations(item)"
                >
                  <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <NoDataTable>Nenhuma nota interna disponível</NoDataTable>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogEditCheckout = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingEditCheckout"
                  :disabled="loadingEditCheckout"
                  x-large
                  @click="saveEditCheckout()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG CONSUMO HOSPEDE -->
      <!--DIALOG DETALHES DO QUARTO  -->
      <v-dialog
        v-model="dialogConsumption"
        width="700"
      >
        <v-card>
          <BarTitleDialog
            :title="'Consumo do quarto - ' + roomDescription"
            @close="dialogConsumption = false"
          >
          </BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <h3>Hospedagem:</h3>
                <v-row no-gutters>
                  <v-col cols="7">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(accommodation, index) in room.accommodationItemsCurrent"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    HOSPEDAGEM {{ formatDate(accommodation.date_start) + '
                    - '+formatDate(accommodation.date_end)}}
                  </v-col>
                  <v-col class="text-right">
                    1,00
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                </v-row>
                <v-row
                  v-for="(accommodation, index) in room.current_accommodation.extra_items"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    {{ accommodation.description }}
                  </v-col>
                  <v-col class="text-right">
                    1,00
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(accommodation.value) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalAccommodation) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <h3>Produtos:</h3>
                <v-row no-gutters>
                  <v-col cols="7">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(product, index) in room.current_accommodation.product"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    {{ product.description }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(product.pivot.quantity) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(product.sale_price) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(product.sale_price * product.pivot.quantity) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalProduct) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3>Serviços:</h3>
                <v-row no-gutters>
                  <v-col cols="7">
                    <b>DESCRIÇÃO</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>QTD.</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>P.UNIT</b>
                  </v-col>
                  <v-col class="text-right">
                    <b>SUB. TOTAL</b>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row
                  v-for="(service, index) in room.current_accommodation.service"
                  :key="index"
                  no-gutters
                >
                  <v-col cols="7">
                    {{ service.description }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(service.pivot.quantity) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(service.sale_price) }}
                  </v-col>
                  <v-col class="text-right">
                    {{ formatMoney(service.sale_price * service.pivot.quantity) }}
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters>
                  <v-col cols="9">
                    <b>Total (R$):</b>
                  </v-col>
                  <v-col><b></b></v-col>
                  <v-col><b></b></v-col>
                  <v-col class="text-right">
                    <b>{{ formatMoney(totalService) }}</b>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="text-right"
                style="font-size:16px"
              >
                Impostos (R$): <div
                  style="float:right;width:70px"
                >
                  {{ formatMoney(room.tax) }}
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                cols="12"
                class="text-right"
                style="color:black;font-size:16px"
              >
                <b> Total (R$): <div
                  style="float:right;width:70px"
                >{{ formatMoney(totalAmount) }}</div></b>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  class="mr-2"
                  color="secondary"
                  :loading="loadingPrintAcommodation"
                  :disabled="loadingPrintAcommodation"
                  x-large
                  @click="printAccommodation()"
                >
                  <v-icon>
                    {{ icons.mdiPrinter
                    }}
                  </v-icon>&nbsp Imprimir Hospedagem
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingPrintConsumption"
                  :disabled="loadingPrintConsumption"
                  x-large
                  @click="printDetails()"
                >
                  <v-icon>{{ icons.mdiPrinter }}</v-icon>&nbsp Imprimir COnsumo
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG OBSERVAÇÃO -->
      <v-dialog
        v-model="dialogObs"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Observações"
            @close="dialogObs = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="roomObs"
                  :error-messages="errorTransfJustification"
                  outlined
                  rows="3"
                  label="Observação"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogObs = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingTransf"
                  :disabled="loadingTransf"
                  x-large
                  @click="saveObs()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogInternalNotes"
        width="700"
      >
        <v-card>
          <BarTitleDialog
            title="Notas Internas"
            @close="dialogInternalNotes = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :headers="headers_observation"
              :items="accommodation_observations"
              :loading="loadingObservation"
              class="elevation-1"
              dense
              hide-default-header
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  dense
                >
                  <v-toolbar-title>Notas internas</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    @click="showDialogObsCheckout()"
                  >
                    <v-icon left>
                      {{ icons.mdiPlus }}
                    </v-icon>
                    Adicionar nota
                  </v-btn>
                </v-toolbar>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  icon
                  color="error"
                  aria-label="Excluir nota interna"
                  :disabled="loadingObservation"
                  @click="removeObservations(item)"
                >
                  <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <NoDataTable>Nenhuma nota interna disponível</NoDataTable>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              x-large
              @click="dialogInternalNotes = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG OBSERVAÇÃO -->
      <v-dialog
        v-model="dialogObsCheckout"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Observações"
            @close="dialogObsCheckout = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="onservation_input"
                  :error-messages="errorObservation"
                  outlined
                  rows="2"
                  label="Nota interna"
                  @input="errorObservation = null"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogObsCheckout = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingObservation"
                  :disabled="loadingObservation"
                  x-large
                  @click="addObservation()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG Alterar Placa -->
      <v-dialog
        v-model="dialogChangeLicensePlate"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Alterar Placa Veículo"
            @close="dialogChangeLicensePlate = false"
          ></BarTitleDialog>
          <v-card-text>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="licensePlate"
                  label="Placa do veículo"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="dialogChangeLicensePlate = false"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  x-large
                  @click="saveLicensePlate()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG  AUTHORIZATION  -->
      <v-dialog
        v-model="dialogAuthorization"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Autorizar"
            @close="cancelAuthorization"
          />
          <v-card-text>
            <v-row class="mt-3">
              <v-col>
                <v-text-field
                  v-model="admLogin.email"
                  outlined
                  label="Email"
                  placeholder="Digite seu email"
                  hide-details="auto"
                  class="mb-6 mt-2"
                  :error-messages="message_error_email"
                  @keyup="validEmail"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="admLogin.password"
                  outlined
                  label="Senha"
                  type="password"
                  placeholder="Digite sua senha"
                  hide-details="auto"
                  :error-messages="message_error_email"
                  @keyup="validPassword"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  class="mr-2"
                  x-large
                  :disabled="authorizationProcessing"
                  @click="cancelAuthorization()"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  x-large
                  :loading="authorizationProcessing"
                  :disabled="authorizationProcessing"
                  @click="requestAuthorization()"
                >
                  Autorizar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- DIALOG Exta Diaria -->
      <v-dialog
        v-model="dialogExtra"
        width="600"
      >
        <v-card>
          <BarTitleDialog
            title="Tarifas Extraordinárias"
            @close="closeExtraDialog"
          ></BarTitleDialog>
          <v-card-text>
            <v-row
              v-for="item in accommodation_exta"
              :key="index"
              no-gutters
              class="mb-2"
            >
              <v-col cols="3">
                <vuetify-money
                  v-model="item.value"
                  :option="{ prefix: 'R$' }"
                  dense
                  outlined
                  hide-details
                  :disabled="item.hotel_day_id != null"
                ></vuetify-money>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="item.description"
                  hide-details=""
                  class="ml-2"
                  outlined
                  dense
                  label="Descrição"
                  :disabled="item.hotel_day_id != null"
                  @blur=""
                ></v-text-field>
              </v-col>
              <v-col
                v-if="item.hotel_day_id != null"
                cols="1"
                class="d-flex align-center justify-center"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="warning"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ icons.mdiLock }}
                    </v-icon>
                  </template>
                  <span>Item auditado - Não pode ser editado</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-center">
                <v-btn
                  color="primary"
                  class="ml-2"
                  @click="addExtraItem()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar Tarifa
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-btn
                  color="error"
                  class="ml-2"
                  @click="addExtraItemDiscount()"
                >
                  <v-icon>{{ icons.mdiPlus }}</v-icon>Adicionar Desconto
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  text
                  x-large
                  class="mr-4"
                  @click="closeExtraDialog"
                >
                  Fechar
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="loadingEditCheckout"
                  :disabled="loadingEditCheckout"
                  x-large
                  @click="updateExtraTariff()"
                >
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-text>
  </div>
</template>

<script>
import {
  mdiDeleteOutline, mdiPlus, mdiMinus, mdiMenu, mdiLock, mdiCheckboxMarked, mdiCheckboxBlankOutline, mdiPrinter,
} from '@mdi/js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AutocompleteSearchProduct from '@/components/AutocompleteSearchProduct.vue'
import AutocompleteSearchService from '@/components/AutocompleteSearchService.vue'
import TableGuestBusy from './TableGuestBusy.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import SelectRoom from '@/components/SelectRoom.vue'
import SelectRoomOccupied from '@/components/SelectRoomOccupied.vue'
import SelectPdv from '@/components/SelectPdv.vue'
import cash from '@/store/cash/cash'

export default {
  components: {
    BarTitleDialog,
    AutocompleteSearchProduct,
    SelectRoom,
    AutocompleteSearchService,
    SelectPdv,
    TableGuestBusy,
    SelectRoomOccupied,

  },
  props: {
    room: {
      type: Object,
    },
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    // DIALOG CONSUMPTION
    dialogConsumption: false,
    loadingPrintConsumption: false,
    loadingPrintAcommodation: false,
    roomDescription: '',

    // DIALOG CANCELAR
    dialogCancel: false,
    errorCancelInput: null,
    cancelInput: '',

    loading: false,

    // Admin Status
    admRole: {},
    dialogAuthorization: false,
    message_error_email: '',
    message_error_password: '',
    admLogin: {
      email: '',
      password: '',
    },
    authorizationProcessing: false,
    pendingAuthorization: null,

    // Contexto original para autorização
    originalContext: {
      user_id: null,
      cash_id: null,
    },

    // Extra Diaria
    dialogExtra: false,
    accommodation_exta: [],

    // Avulsa
    dialogOutstanding: false,

    // Observações
    accommodation_observations: [],
    onservation_input: '',
    errorObservation: null,
    loadingObservation: false,
    dialogInternalNotes: false,
    headers_observation: [
      {
        text: 'Observações',
        sortable: false,
        align: 'start',
        value: 'description',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
    loadingAddProduct: false,
    tab: null,
    loadingTransf: false,
    roomId: null,
    transfJustification: '',
    errorTransfJustification: null,
    errorRoomTransf: null,
    dialogTranfRoom: false,
    dialogTranfItens: false,
    dialogTranfDiarias: false,
    errorQtyRemoveProduct: null,
    dialogRoom: false,
    descriptionRoom: '',
    editedItemLoading: false,

    // PAGAMNETO PARCIAL
    loadingPayment: false,

    // PRODUTO
    loadingRemovedProduct: false,
    obsRemoveProduct: '',
    errorObsRemoveProduct: null,
    btnQtyRemoveProduct: false,
    dialogQty: false,
    dialogRemoveQty: false,
    qtyRemoveProduct: 1,
    qtyCurrentProduct: 0,
    productRemove: {},
    products: [],
    qtyProduct: 1,
    product: null,
    errorQtyProduct: null,
    btnAddQtyProduct: false,
    loadingPrintProduct: false,
    productsPrint: [],
    pdv: 1,

    // EDITAR CHECKOUT
    dialogEditCheckout: false,
    accommodation_items: [],
    loadingEditCheckout: false,

    // LANÇAMENTO
    postedItems: [],

    // TRANSFERENCIA DE ITENS
    sendItens: [],

    // TRANSFERENCIA DE DIÁRIAS
    sendDiarias: [],

    // SERVIÇO
    services: [],
    service: null,
    dialogQtyService: false,
    qtyService: 1,
    errorQtyService: null,
    dialogRemoveQtyService: false,
    qtyRemoveService: 1,
    errorQtyRemoveService: null,
    qtyCurrentService: 0,
    obsRemoveService: '',
    errorObsRemoveService: null,
    loadingRemovedService: false,
    btnQtyRemoveService: false,
    serviceRemove: {},
    cashItems: [],
    cashId: null,

    // DIALOG Observação
    dialogObs: false,
    roomObs: '',

    // DIALOG Authorization
    dialogAuthorization: false,

    // DIALOG Alterar Placa
    dialogChangeLicensePlate: false,
    licensePlate: '',

    dialogObsCheckout: false,

    // HOSPEDE
    guests: [],
    headers_guests: [
      {
        text: 'NOME',
        align: 'start',
        value: 'name',
      },
      {
        text: 'TELEFONE',
        value: 'cell_phone',
      },
      {
        text: 'EMAIL',
        value: 'email',
      },
    ],

    headers: [
      {
        text: 'PRODUTO',
        align: 'start',
        value: 'description',
      },
      {
        text: 'Ponto de Venda',
        align: 'center',
        value: 'pdv',
      },
      {
        text: 'QTDE',
        align: 'center',
        value: 'qty',
      },
      {
        text: 'P. UND. (R$)',
        align: 'right',
        value: 'sale_price',
      },
      {
        text: 'TOTAL',
        align: 'right',
        value: 'total',
      },
      {
        text: '',
        align: 'center',
        value: 'print',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
    headers_service: [
      {
        text: 'PRODUTO',
        align: 'start',
        value: 'description',
      },

      {
        text: 'QTDE',
        align: 'center',
        value: 'qty',
      },
      {
        text: 'P. UND. (R$)',
        align: 'right',
        value: 'sale_price',
      },
      {
        text: 'TOTAL',
        align: 'right',
        value: 'total',
      },
      {
        text: '',
        align: 'end',
        value: 'action',
      },
    ],
    statusItems: [
      {
        value: 'sujo',
        text: 'Sujo',
      },
      {
        value: 'bloqueado',
        text: 'Bloqueado',
      },
      {
        value: 'diaria',
        text: 'Diaria',
      },
      {
        value: 'disponivel',
        text: 'Disponível',
      },
      {
        value: 'conferencia',
        text: 'Conferência',
      },
      {
        value: 'encerramento',
        text: 'Encerramento',
      },
      {
        value: 'limpeza',
        text: 'Limpeza',
      },
      {
        value: 'manutencao',
        text: 'Manutenção',
      },
      {
        value: 'ocupado',
        text: 'Ocupado',
      },
      {
        value: 'periodo',
        text: 'Período',
      },
      {
        value: 'pernoite',
        text: 'Pernoite',
      },
      {
        value: 'reservado',
        text: 'Reservado',
      },
      {
        value: 'stand-by',
        text: 'Stand-by',
      },
    ],
    rooms: [],
    editedItem: {},
    indexItem: null,
    icons: {
      mdiDeleteOutline,
      mdiPlus,
      mdiMinus,
      mdiMenu,
      mdiLock,
      mdiCheckboxMarked,
      mdiCheckboxBlankOutline,
      mdiPrinter,
    },
  }),
  watch: {
    value(val) {
      if (val) {
        this.products = this.room.current_accommodation.product
        this.services = this.room.current_accommodation.service
        this.guests = this.room.current_accommodation.guest
        this.roomObs = this.room.current_accommodation.observation
        this.storeCheckout()
        this.loadRooms('disponivel') // carrega todos os quartos disponivel da tela de transferir quarto
      }
    },
    qtyProduct() {
      if (this.qtyProduct > 0) {
        this.errorQtyProduct = null
        this.btnAddQtyProduct = false
      } else {
        this.errorQtyProduct = 'Quantidade deve ser maior que zero'
        this.btnAddQtyProduct = true
      }
    },
    qtyRemoveProduct() {
      if (this.qtyRemoveProduct <= this.qtyCurrentProduct) {
        this.errorQtyRemoveProduct = null
        this.btnQtyRemoveProduct = false
      } else {
        this.errorQtyRemoveProduct = 'Quantidade retirada dever ser menor ou igual a quantidade atual'
        this.btnQtyRemoveProduct = true
      }
    },
    room(val) {
      if (val) {
        this.products = val.current_accommodation.product
        this.services = val.current_accommodation.service
        this.guests = val.current_accommodation.guest
        this.roomDescription = val.description
        this.licensePlate = val.current_accommodation.car_license_plate
      }
    },

    // products(val){
    //   this.$emit('input', val)
    // }
  },

  created() {
    if (this.value) {
      this.products = this.room.current_accommodation.product
      this.services = this.room.current_accommodation.service
      this.guests = this.room.current_accommodation.guest
      this.roomDescription = this.room.description
      this.licensePlate = this.room.current_accommodation.car_license_plate
      this.storeCheckout()
      this.loadRooms('disponivel') // carrega todos os quartos disponivel da tela de transferir quarto
      this.loadCurrentRole()
      this.captureOriginalContext()
    }
    this.cashsOpen().then(response => {
      this.cashItems = response.data
    })
    this.loadPdvs()
    this.inicialize()
    this.checkPrinters()
  },
  computed: {
    ...mapGetters('checkout', ['getSubtotal', 'getTotalToPay', 'getTaxation', 'getTotalAmount']),
    ...mapGetters('select', ['getPdvs']),
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),
    calcTotalProductAmount() {
      const result = this.products.reduce((acc, product) => acc + this.calcTotalProduct(product), 0)

      return result
    },
    calcTotalServiceAmount() {
      const result = this.services.reduce((acc, service) => acc + this.calcTotalService(service), 0)

      return result
    },
    showDialogSelectCash() {
      // verifica se o usario é admin
      this.getUser().then(response => {
        if (response.data.role.name == 'Admin') {
          this.dialogSelectCash = true
        } else {
          this.sendReservePartialPayment()
        }
      })
    },
    calcTotalAccommodation() {
      return this.calcTotalProductAmount + this.room.current_accommodation.accommodation_value
    },
    itemsProducts() {
      // let products_agruped = []
      // this.products.forEach(item => {
      //   let product = products_agruped.find(product => {
      //     return product.id == item.id
      //   })
      //   if (product) {
      //     // se exitir mais de item do mesmo produto soma só a quantidade
      //     product.pivot.quantity += item.pivot.quantity
      //   } else {
      //     products_agruped.push(Object.assign({}, item))
      //   }
      // })
      // return products_agruped
      return this.products
    },
    transItens() {
      const transItens = []
      this.products.forEach(item => {
        transItens.push({ ...item, origin: 'product' })
      })
      this.services.forEach(item => {
        transItens.push({ ...item, origin: 'service' })
      })

      return transItens
    },
    totalProduct() {
      return this.room.current_accommodation.product.reduce((acc, product) => acc + parseFloat(product.pivot.quantity) * parseFloat(product.sale_price), 0)
    },
    totalService() {
      return this.room.current_accommodation.service.reduce((acc, service) => acc + parseFloat(service.pivot.quantity) * parseFloat(service.sale_price), 0)
    },
    totalAccommodation() {
      if (!this.room.accommodationItemsCurrent) {
        return 0
      }
      const accommodation_items_value = this.room.accommodationItemsCurrent.reduce((acc, accomodation) => acc + parseFloat(accomodation.value), 0)
      const accommodation_exta_value = this.room.current_accommodation.extra_items.reduce((acc, accomodation) => acc + parseFloat(accomodation.value), 0)

      return accommodation_items_value + accommodation_exta_value
    },
    totalAmount() {
      return (
        parseFloat(this.totalProduct)
        + parseFloat(this.totalService)
        + parseFloat(this.totalAccommodation)
        + parseFloat(this.room.tax)
      )
    },
    IfOneItem() {
      if (this.accommodation_items.length == 1) {
        return false
      }

      return true
    },
    hasAuditedTariffs() {
      // Verifica se alguma tarifa já foi auditada (tem hotel_day_id)
      return this.accommodation_items.some(item => item.hotel_day_id)
    },
    allItemsSelected() {
      // Verifica se todos os itens estão marcados
      return this.transItens.length > 0 && this.transItens.every(item => item.checked)
    },
    transDiarias() {
      // Apenas diárias não auditadas podem ser transferidas
      return (this.room.current_accommodation.accommodation_item || []).filter(item => !item.hotel_day_id)
    },
    allDiariasSelected() {
      return this.transDiarias.length > 0 && this.transDiarias.every(item => item.checked)
    },
  },
  methods: {
    ...mapActions('outstanding', ['storeOutstanding', 'updateOutstanding', 'exportAccommodationPdf', 'exportConsumptionPdf', 'storeTransfRoom', 'storeTransItens', 'storeTransDiarias']),
    ...mapActions('busy', ['storeItemRemoved', 'updateEditCheckout', 'updateExtraTarrif', 'getAccommodationObservations', 'updateObservations', 'printProduct']),
    ...mapActions('open_account', ['`exportDetailsPdf`']),
    ...mapActions('select', ['loadRooms', 'loadPdvs']),
    ...mapActions('manager_room', ['getAllRoom']),
    ...mapActions('printers', { listPrinters: 'listPrinters' }),
    ...mapMutations('checkout', [
      'setRoom',
      'setCheckout',
      'setStage',
      'clearCheckoutSeparete',
      'setOriginPartialPayment',
    ]),
    ...mapActions('checkout', ['cashsOpen', 'getUser', 'loadCurrentRole', 'sendReservePartialPayment', 'storeCheckout']),

    ...mapActions('select', ['loadAdmRole']),
    ...mapActions('cash', ['getCash']),
    ...mapActions('authorization', { runAuthorization: 'run' }),

    // modficar data primeiro data em editar checkout
    changeAccomodation() {
      const next_date = new Date(this.accommodation_items[0].date_start)
      next_date.setDate(next_date.getDate() + 1)
      const next_date1 = `${next_date.toISOString().substring(0, 10)} 14:00:00`

      this.accommodation_items[0].date_end = next_date1
    },

    // imprimir
    printDetails() {
      this.loadingPrintConsumption = true
      this.exportConsumptionPdf(this.room)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {

        })
        .finally(() => {
          this.loadingPrintConsumption = false
        })
    },
    printAccommodation() {
      this.loadingPrintAcommodation = true
      this.exportAccommodationPdf(this.room)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {

        })
        .finally(() => {
          this.loadingPrintAcommodation = false
        })
    },

    // Add Guest
    updateGuest() {
      this.save()
    },

    // DIALOG DE EDITAR CHECKOUT
    showEditCheckout() {
      this.dialogEditCheckout = true
      this.accommodation_items = this.room.current_accommodation.accommodation_item
      this.loadObservations()
    },

    showInternalNotes() {
      this.loadObservations()
      this.dialogInternalNotes = true
    },

    loadObservations() {
      const accommodationId = this.room.current_accommodation && this.room.current_accommodation.id
      if (!accommodationId) return

      this.getAccommodationObservations(accommodationId).then(response => {
        this.accommodation_observations = response.data
      })
    },
    addObservation() {
      const description = this.onservation_input.trim()
      if (!description) {
        this.errorObservation = 'Informe a nota interna'

        return
      }

      this.loadingObservation = true
      const observations = [
        ...this.accommodation_observations,
        {
          accommodation_id: this.room.current_accommodation.id,
          description,
        },
      ]

      this.updateObservations({
        accommodation_id: this.room.current_accommodation.id,
        observations,
      }).then(response => {
        this.accommodation_observations = response.data
        this.onservation_input = ''
        this.dialogObsCheckout = false
      }).finally(() => {
        this.loadingObservation = false
      })
    },
    removeObservations(item) {
      const observations = this.accommodation_observations.filter(observation => observation.id !== item.id)
      this.loadingObservation = true
      this.updateObservations({
        accommodation_id: this.room.current_accommodation.id,
        observations,
      }).then(response => {
        this.accommodation_observations = response.data
      }).finally(() => {
        this.loadingObservation = false
      })
    },
    showDialogObsCheckout() {
      this.onservation_input = ''
      this.errorObservation = null
      this.dialogObsCheckout = true
    },

    // dialogConsumption
    showDialogConsumption() {
      this.dialogConsumption = true
    },

    showDialogObs() {
      this.dialogObs = true
    },
    showdialogChangeLicensePlate() {
      this.dialogChangeLicensePlate = true
    },

    addAccommodationItem() {
      const lastItem = this.accommodation_items[this.accommodation_items.length - 1]
      const date_end = new Date(lastItem.date_end)
      const date_end1 = `${date_end.toISOString().substring(0, 10)} 14:00:00`
      const next_date = new Date(date_end1)
      next_date.setDate(date_end.getDate() + 1)
      const next_date1 = `${next_date.toISOString().substring(0, 10)} 14:00:00`

      // Usa o valor da última tarifa ao invés de 0
      const lastValue = Number(lastItem.value) || 0

      this.accommodation_items.push({ value: lastValue, date_start: date_end1, date_end: next_date1 })
    },
    removeAccommodationItem() {
      // Verifica se há apenas uma tarifa
      if (this.accommodation_items.length <= 1) {
        this.$toast.error('Não é permitido remover todas as tarifas. Deve haver pelo menos uma diária.')

        return
      }

      // Verifica se a última tarifa está auditada
      const lastItem = this.accommodation_items[this.accommodation_items.length - 1]
      if (lastItem.hotel_day_id) {
        this.$toast.error('Não é possível remover tarifas que já foram auditadas.')

        return
      }

      // Verifica autorização
      if (this.admRole.authorization) {
        this.accommodation_items.pop()
      } else {
        this.dialogAuthorization = true
      }
    },
    saveEditCheckout() {
      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        accommodation_item: this.accommodation_items,
      }

      // Tenta executar diretamente - se der 403, performUpdateAccommodationItem abrirá dialog
      this.performUpdateAccommodationItem(payload)
    },

    performUpdateAccommodationItem(payload) {
      this.loadingEditCheckout = true

      this.updateEditCheckout(payload)
        .then(response => {
          this.$toast.success('Diárias atualizadas com sucesso')
          this.dialogEditCheckout = false
          this.room.accommodationItemsCurrent = response.data.accommodationItemsCurrent
          this.room.totalRoomCurrent = response.data.totalRoomCurrent
          this.storeCheckout()
        })
        .catch(error => {
          // CHAVE: Detecta 403 e solicita autorização
          if (error?.response?.status === 403) {
            this.dialogAuthorization = true // Abre dialog do sistema antigo

            return
          }

          // Erro 422 - validação de negócio (tarifa auditada, etc)
          if (error.response?.status === 422 && error.response?.data?.error) {
            this.$toast.error(error.response.data.error)
            if (error.response.data.message) {
              this.$toast.warning(error.response.data.message)
            }
          } else {
            this.$toast.error('Erro ao atualizar tarifas')
          }
        })
        .finally(() => {
          this.loadingEditCheckout = false
          this.loadCurrentRole()
        })
    },

    sendPrintProduct() {
      this.loadingPrintProduct = true
      const printerKeys = this.getPrinterKeys()

      if (!printerKeys.length) {
        this.$toast.error('Selecione ao menos uma impressora ao abrir o caixa')
        this.loadingPrintProduct = false

        return
      }

      const data = {
        accommodation_id: this.room.current_accommodation_id,
        printer_keys: printerKeys,
      }

      this.printProduct(data)
        .then(response => {
          this.$toast.success('Pedido enviado para impressão')
        })
        .catch(() => {})
        .finally(() => {
          this.loadingPrintProduct = false
        })
    },
    reprintProduct(item) {
      this.loadingPrintProduct = true
      const printerKeys = this.getPrinterKeys()

      if (!printerKeys.length) {
        this.$toast.error('Selecione ao menos uma impressora ao abrir o caixa')
        this.loadingPrintProduct = false

        return
      }

      const data = {
        accommodation_id: this.room.current_accommodation_id,
        printer_keys: printerKeys,
        product_id: item.id,
        pdv_id: item?.pivot?.pdv_id,
      }

      this.printProduct(data)
        .then(() => {
          this.$toast.success('Produto reenviado para impressão')
        })
        .catch(() => {})
        .finally(() => {
          this.loadingPrintProduct = false
        })
    },
    async checkPrinters() {
      try {
        const response = await this.listPrinters()
        this.hasPrinters = (response.data || []).length > 0
      } catch (e) {
        this.hasPrinters = false
      }
    },
    getPrinterKeys() {
      try {
        const saved = localStorage.getItem('printerSelection')
        if (!saved) return []
        const parsed = JSON.parse(saved)
        if (Array.isArray(parsed)) {
          return parsed
            .map(item => item?.printer_key || item?.printer?.printer_key)
            .filter(key => !!key)
        }

        return parsed?.printer_key ? [parsed.printer_key] : []
      } catch (e) {
        return []
      }
    },
    inicialize() {
      this.getAllRoom().then(response => {
        this.rooms = response.data
      })
    },

    // TRASNFERENCIA DE QUARTO
    showTranfRoom() {
      this.dialogTranfRoom = true
      this.loadRooms('disponivel')
    },
    sendTransItens() {
      if (this.sendItens.length == 0) {
        this.$toast.error('Nenhum item selecionado')

        return false
      }
      if (this.roomId == null || this.roomId == undefined) {
        this.errorRoomTransf = 'Campo Obrigatório'

        return false
      }
      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }

      const payload = {
        room_id: this.roomId,
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendItens,
        justification: this.transfJustification,
        outstanding_id: this.room.id,
        cash_id: this.cashId,
      }
      this.storeTransItens(payload).then(response => {
        this.dialogTranfItens = false
        this.roomId = ''
        this.$toast.success('Transferido com sucesso')
        this.$router.push({
          name: 'manager_room',
        })
      })
    },
    sendTransItensOutstanding() {
      if (this.sendItens.length == 0) {
        this.$toast.error('Nenhum item selecionado')

        return false
      }

      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }
      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendItens,
        justification: this.transfJustification,
      }
      this.storeTransItensOutstanding(payload).then(response => {
        this.dialogTranfItens = false
        this.roomId = ''
        this.$toast.success('Transferido com sucesso')
        this.$router.push({
          name: 'manager_room',
        })
      })
    },
    addItemToSend(item) {
      if (item.checked) {
        // Adiciona se não existir
        if (!this.sendItens.find(i => i.id === item.id)) {
          this.sendItens.push(item)
        }
      } else {
        // Remove se existir
        const index = this.sendItens.findIndex(i => i.id === item.id)
        if (index > -1) {
          this.sendItens.splice(index, 1)
        }
      }
    },
    showTranfDiarias() {
      this.dialogTranfDiarias = true
      this.loadRooms('disponivel')
    },
    sendTransDiarias() {
      if (this.sendDiarias.length == 0) {
        this.$toast.error('Nenhuma diária selecionada')

        return false
      }
      if (this.roomId == null || this.roomId == undefined) {
        this.errorRoomTransf = 'Campo Obrigatório'

        return false
      }
      if (this.transfJustification == '') {
        this.errorTransfJustification = 'Campo Obrigatório'

        return false
      }

      const payload = {
        room_id: this.roomId,
        accommodation_id: this.room.current_accommodation.id,
        items: this.sendDiarias,
        justification: this.transfJustification,
        outstanding_id: this.room.id,
        cash_id: this.cashId,
      }
      this.storeTransDiarias(payload).then(response => {
        this.dialogTranfDiarias = false
        this.roomId = ''
        this.$toast.success('Transferido com sucesso')
        this.$router.push({
          name: 'manager_room',
        })
      })

      return true
    },
    addDiariaToSend(item) {
      if (item.checked) {
        // Adiciona se não existir
        if (!this.sendDiarias.find(i => i.id === item.id)) {
          this.sendDiarias.push(item)
        }
      } else {
        // Remove se existir
        const index = this.sendDiarias.findIndex(i => i.id === item.id)
        if (index > -1) {
          this.sendDiarias.splice(index, 1)
        }
      }
    },
    toggleSelectAllDiarias() {
      const newCheckedState = !this.allDiariasSelected

      if (newCheckedState) {
        // Marcar todas
        this.transDiarias.forEach(item => {
          this.$set(item, 'checked', true)
          if (!this.sendDiarias.find(i => i.id === item.id)) {
            this.sendDiarias.push(item)
          }
        })
      } else {
        // Desmarcar todas
        this.transDiarias.forEach(item => {
          this.$set(item, 'checked', false)
        })
        this.sendDiarias = []
      }
    },
    toggleSelectAll() {
      const newCheckedState = !this.allItemsSelected

      if (newCheckedState) {
        // Marcar todos
        this.transItens.forEach(item => {
          this.$set(item, 'checked', true)
          if (!this.sendItens.find(i => i.id === item.id)) {
            this.sendItens.push(item)
          }
        })
      } else {
        // Desmarcar todos
        this.transItens.forEach(item => {
          this.$set(item, 'checked', false)
        })
        this.sendItens = []
      }
    },
    sendTransfRoom() {
      // valida quarto
      if (this.roomId == null || this.roomId == undefined) {
        this.errorRoomTransf = 'Campo Obrigatório'

        return false
      }

      this.loadingTransf = true
      const transf = {
        accommodation_id: this.room.current_accommodation.id,
        room_id: this.roomId,
        outstanding_id: this.room.id,
      }
      this.storeTransfRoom(transf)
        .then(response => {
          this.dialogTranfRoom = false
          this.roomId = ''
          this.$toast.success('Transferido com sucesso')
          this.$router.push({
            name: 'manager_room',
          })
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    showTranfItens() {
      this.dialogTranfItens = true
      this.loadRooms('disponivel')
    },

    // PRODUTOS
    dialogQtyProduct() {
      this.dialogQty = true
    },
    addProduct() {
      const snapshot = this.captureState()

      const qty = parseInt(this.qtyProduct, 10)

      if (isNaN(qty) || qty <= 0) {
        this.errorQtyProduct = 'Quantidade deve ser um número inteiro maior que zero'

        return false
      }

      this.qtyProduct = qty

      this.product.pivot = {
        quantity: 0,
      }

      this.product.pivot.quantity = this.qtyProduct
      this.productsPrint.push(this.product)

      const postedItem = {
        accommodation_id: this.room.current_accommodation_id,
        product_id: this.product.id,
        quantity: this.qtyProduct,
        pdv_id: this.pdv,
        sale_price: this.product.sale_price,
      }
      this.postedItems.push(postedItem)

      // verifica se exite o produto na lista
      const productExist = this.products.find(item => this.product.id == item.id && item.pivot.pdv_id == this.pdv)

      if (productExist) {
        productExist.pivot.quantity += this.qtyProduct
      } else {
        this.product.pivot.pdv_id = this.pdv
        this.products.push(this.product)
      }

      this.product = ''
      this.qtyProduct = 1

      this.save().catch(() => {
        this.restoreState(snapshot)
      })
    },
    addQtyProduct() {
      this.qtyProduct++
    },
    minusQtyProduct() {
      if (this.qtyProduct > 0) {
        this.qtyProduct--
      }
    },
    dialogRemoveProduct(product) {
      this.productRemove = product
      this.dialogRemoveQty = true
      this.qtyCurrentProduct = product.pivot.quantity
      this.obsRemoveProduct = ''
      this.qtyRemoveProduct = 1
      this.errorQtyRemoveProduct = null
      this.errorObsRemoveProduct = null
      this.btnQtyRemoveProduct = false
    },
    minusQtyRemoveProduct() {
      if (this.qtyRemoveProduct > 0) {
        this.qtyRemoveProduct--
      }
    },
    addQtyRemoveProduct() {
      if (this.qtyRemoveProduct < this.qtyCurrentProduct) {
        this.qtyRemoveProduct++
      }
    },
    removeProduct() {
      if (this.qtyRemoveProduct > this.qtyCurrentProduct) {
        this.errorQtyRemoveProduct = 'Quantidade retirada dever ser menor ou igual a quantidade atual'

        return
      }

      if (!this.obsRemoveProduct || !this.obsRemoveProduct.trim()) {
        this.errorObsRemoveProduct = 'Obrigatório'

        return
      }

      this.errorObsRemoveProduct = null

      const snapshot = this.captureState()

      const productIndex = this.products.findIndex(
        p => p.id === this.productRemove.id && p.pivot.pdv_id === this.productRemove.pivot.pdv_id,
      )

      if (productIndex !== -1) {
        this.products[productIndex].pivot.quantity -= this.qtyRemoveProduct

        if (this.products[productIndex].pivot.quantity <= 0) {
          this.products.splice(productIndex, 1)
        }
      }

      const removeProduct = {
        accommodation_id: this.room.current_accommodation_id,
        product_id: this.productRemove.id,
        quantity: this.qtyRemoveProduct,
        obs: this.obsRemoveProduct,
        pdv_id: this.productRemove.pivot.pdv_id,
      }

      this.performProductRemoval(removeProduct).catch(() => {
        this.restoreState(snapshot)
      })
    },
    calcTotalProduct(product) {
      return product.pivot.quantity * product.sale_price
    },

    // SERVICOS
    showDialogQtyService() {
      this.dialogQtyService = true
    },

    addQtyService() {
      this.qtyService++
    },
    minusQtyService() {
      if (this.qtyService > 0) {
        this.qtyService--
      }
    },
    addService() {
      const snapshot = this.captureState()
      if (this.qtyService == 0) {
        this.errorQtyService = 'Quantidade deve ser maior que zero'

        return false
      }
      this.service.pivot = {
        quantity: 0,
      }
      this.service.pivot.quantity = this.qtyService
      this.services.push(this.service)

      const postedItem = {
        accommodation_id: this.room.current_accommodation_id,
        service_id: this.service.id,
        quantity: this.qtyService,
        sale_price: this.service.sale_price,
      }

      this.postedItems.push(postedItem)

      this.dialogQtyService = false
      this.service = ''
      this.qtyService = 1
      this.save().catch(() => {
        this.restoreState(snapshot)
      })
    },
    calcTotalService(service) {
      return service.pivot.quantity * service.sale_price
    },
    dialogRemoveService(service) {
      this.serviceRemove = service
      this.dialogRemoveQtyService = true
      this.qtyCurrentService = service.pivot.quantity
      this.obsRemoveService = ''
      this.qtyRemoveService = 1
      this.errorQtyRemoveService = null
      this.errorObsRemoveService = null
      this.btnQtyRemoveService = false
    },
    minusQtyRemoveService() {
      if (this.qtyRemoveService > 0) {
        this.qtyRemoveService--
      }
    },
    addQtyRemoveService() {
      if (this.qtyRemoveService < this.qtyCurrentService) {
        this.qtyRemoveService++
      }
    },
    removeService() {
      if (this.qtyRemoveService > this.qtyCurrentService) {
        this.errorQtyRemoveService = 'Quantidade retirada dever ser menor ou igual a quantidade atual'

        return
      }

      if (!this.obsRemoveService || !this.obsRemoveService.trim()) {
        this.errorObsRemoveService = 'Obrigatório'

        return
      }

      this.errorObsRemoveService = null

      const snapshot = this.captureState()

      const serviceIndex = this.services.findIndex(
        s => s.id === this.serviceRemove.id,
      )

      if (serviceIndex !== -1) {
        this.services[serviceIndex].pivot.quantity -= this.qtyRemoveService

        if (this.services[serviceIndex].pivot.quantity <= 0) {
          this.services.splice(serviceIndex, 1)
        }
      }

      const removeService = {
        accommodation_id: this.room.current_accommodation_id,
        service_id: this.serviceRemove.id,
        quantity: this.qtyRemoveService,
        obs: this.obsRemoveService,
      }

      this.performServiceRemoval(removeService).catch(() => {
        this.restoreState(snapshot)
      })
    },

    // changeQtyProduct(){
    //   if (this.qtyProduct > 0) {
    //     this.errorQtyProduct = null
    //   }
    // },
    save(room) {
      if (this.loading) return Promise.reject(new Error('Operação em andamento')) // se estiver carregando não salva novamente
      this.loading = true

      this.room.products = this.products
      this.room.services = this.services
      this.room.products_print = this.productsPrint
      this.room.posted_items = this.postedItems
      this.room.guests = this.guests
      this.room.observation = this.roomObs
      this.room.licensePlate = this.licensePlate
      this.editedItemLoading = true

      return this.updateOutstanding(this.room)
        .then(response => {
          this.$emit('updategrid')

          // atualiaza os produtos do quarto no front-end
          const products = response.data.current_accommodation.product

          // this.room.current_accommodation.product = products
          // this.products = products
          this.dialogQty = false // didalog adicionar produtos
          // this.$emit('close')
          this.productsPrint = []
          this.postedItems = []
          this.$toast.success('Salvo com sucesso')
          this.storeCheckout()

          return response
        })
        .catch(error => {
          const message = error?.response?.data?.message || 'Erro ao salvar alterações'
          this.$toast.error(message)
          throw error
        })
        .finally(() => {
          this.cleanProducts()
          this.loadingAddProduct = false
          this.loading = false
          this.editedItemLoading = false
        })
    },

    saveObs() {
      this.dialogObs = false
      this.save()
    },
    saveLicensePlate() {
      this.dialogChangeLicensePlate = false
      this.save()
    },
    closeAccount() {
      this.$emit('close')
      this.$router.push({
        name: 'checkout',
      })
      this.setStage('payment')

      // this.setRoom(this.room)

      this.clearCheckoutSeparete()
      this.storeCheckout()
      this.setOriginPartialPayment('checkout')
    },

    partialPayment() {
      this.$emit('close')
      this.$router.push({
        name: 'checkout',
      })
      this.setStage('payment')
      this.clearCheckoutSeparete()
      this.storeCheckout()
      this.setOriginPartialPayment('accommodation')
    },

    storeCheckout() {
      if (!this.room.accommodationItemsCurrent) {
        this.room.accommodationItemsCurrent = []
      }
      this.setRoom(this.room)
      this.products.map(product => (product.origin = 'product')) // propriedade define no checkout quem é produto ou serviço
      this.services.map(service => (service.origin = 'service')) // propriedade define no checkout quem é produto ou serviço
      this.room.accommodationItemsCurrent.map(item => {
        item.origin = 'accommodation'
        item.pivot = { quantity: 1 }
        item.sale_price = item.value
        item.description = `HOSPEDAGEM ${this.formatDate(item.date_start)} - ${this.formatDate(item.date_end)}`

        return item
      })
      this.room.current_accommodation.extra_items.map(item => {
        item.origin = 'extra_tarif'
        item.pivot = { quantity: 1 }
        item.sale_price = item.value

        return item
      })
      const accommodation_item = this.room.accommodationItemsCurrent
      const accommodation_exta = this.room.current_accommodation.extra_items
      const checkoutItems = this.products.concat(this.services, accommodation_item, accommodation_exta)
      this.room.tax = this.calculateRoomTax(accommodation_item)
      this.setCheckout(checkoutItems) // junta produto e servico para mostrar no checkout
    },
    calculateRoomTax(accommodationItems = []) {
      const parseNumber = value => {
        const parsed = parseFloat(value)

        return Number.isNaN(parsed) ? 0 : parsed
      }

      const serviceTax = this.services.reduce((total, service) => {
        const issPercent = parseNumber(service.iss)
        if (issPercent <= 0) {
          return total
        }
        const salePrice = parseNumber(service.sale_price)
        const quantity = parseNumber(service?.pivot?.quantity ?? 0)

        return total + (issPercent / 100) * salePrice * quantity
      }, 0)

      const applyAccommodationIss = this.room?.current_accommodation?.with_iss === 'yes'
      const accommodationTax = applyAccommodationIss
        ? accommodationItems.reduce((total, item) => total + this.issRate * parseNumber(item.sale_price), 0)
        : 0

      return serviceTax + accommodationTax
    },
    status(status) {
      switch (status) {
        case 'sujo':
          return 'Sujo'
        case 'bloqueado':
          return 'Bloqueado'
        case 'diaria':
          return 'Diária'
        case 'disponivel':
          return 'Disponível'
        case 'conferencia':
          return 'Conferência'
        case 'encerramento':
          return 'Encerramento'
        case 'limpeza':
          return 'Limpeza'
        case 'manutencao':
          return 'Manutenção'
        case 'ocupado':
          return 'Ocupado'
        case 'periodo':
          return 'Período'
        case 'pernoite':
          return 'Pernoite'
        case 'reservado':
          return 'Reservado'
        case 'stand-by':
          return 'Stand-by'
      }
    },
    formatMoney(value) {
      value = parseFloat(value)
      if (value != null) {
        return value.toLocaleString('pt-br', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }
    },
    formatDateTime(date) {
      if (date) {
        const result = new Date(date)

        return (
          `${result.toLocaleDateString('pt-BR', {
            timeZone: 'America/Sao_Paulo',
          })
          } ${
            result.toLocaleTimeString('pt-BR')}`
        )
      }
    },
    cleanProducts() {
      const product = this.products.find(product => product.pivot.quantity == 0)
      if (product) {
        const index = this.products.indexOf(product)
        this.products.splice(index, 1)
      }
    },
    pdvDescription(pdv_id) {
      const pdv = this.getPdvs.find(pdv => pdv.id == pdv_id)

      return pdv ? pdv.description : ''
    },
    formatDate(date) {
      if (date) {
        const result = new Date(date)

        return result.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      }
    },

    // AUTHORIZATION
    requestAuthorization() {
      if (!this.validEmail() || !this.validPassword()) return

      // Ação pendente de remoção de produto/serviço: usa o fluxo novo com retry via token
      const pending = this.pendingAuthorization
      if (pending) {
        const credentials = {
          email: this.admLogin.email,
          password: this.admLogin.password,
        }

        // Backend valida as permissões específicas
        const validate = () => true

        const request = token => {
          switch (pending.type) {
            case 'product':
              return this.performProductRemoval(pending.payload, token)
            case 'service':
              return this.performServiceRemoval(pending.payload, token)
            default:
              return Promise.resolve()
          }
        }

        this.authorizationProcessing = true

        this.runAuthorization({ credentials, validate, request })
          .then(() => {
            this.admRole.authorization = true
            this.dialogAuthorization = false
            this.pendingAuthorization = null
            this.$toast.success('Usuário autorizado')
          })
          .catch(error => {
            const message = error?.response?.data?.message || error?.message || 'Usuário não autorizado'
            this.$toast.error(message)
          })
          .finally(() => {
            this.authorizationProcessing = false
            this.admLogin.email = ''
            this.admLogin.password = ''
            this.message_error_email = ''
            this.message_error_password = ''
          })

        return
      }

      const credentials = {
        email: this.admLogin.email,
        password: this.admLogin.password,
      }
      this.loadAdmRole(credentials).then(response => {
        this.admRole = response.data

        if (this.admRole.authorization) {
          this.dialogAuthorization = false
          this.$toast.success('Usuário autorizado')
        } else {
          this.$toast.error(this.admRole.error)
        }
      }).catch(() => {
        this.$toast.error('Usuário não autorizado')
      }).finally(() => {
        this.admLogin.email = ''
        this.admLogin.password = ''
      })
    },
    cancelAuthorization() {
      this.dialogAuthorization = false
      this.pendingAuthorization = null
      this.admLogin.email = ''
      this.admLogin.password = ''
      this.message_error_email = ''
      this.message_error_password = ''
      this.authorizationProcessing = false
    },
    queueAuthorization(type, payload = null) {
      this.pendingAuthorization = { type, payload }
      this.dialogAuthorization = true
    },
    captureOriginalContext() {
      this.getUser().then(response => {
        this.originalContext.user_id = response.data.id
      })

      this.getCash().then(response => {
        if (response.data && response.data.id) {
          this.originalContext.cash_id = response.data.id
        } else {
          this.originalContext.cash_id = null
        }
      }).catch(() => {
        this.originalContext.cash_id = null
      })
    },
    addOriginalContext(payload, hasToken) {
      // Adiciona contexto original apenas quando há token temporário
      if (hasToken && this.originalContext.user_id) {
        const context = {
          ...payload,
          _original_user_id: this.originalContext.user_id,
        }

        if (this.originalContext.cash_id) {
          context._original_cash_id = this.originalContext.cash_id
        }

        return context
      }

      return payload
    },
    cloneDeep(value) {
      if (value === undefined) return undefined

      return JSON.parse(JSON.stringify(value))
    },
    captureState() {
      return {
        products: this.cloneDeep(this.products),
        services: this.cloneDeep(this.services),
        productsPrint: this.cloneDeep(this.productsPrint),
        postedItems: this.cloneDeep(this.postedItems),
        room: {
          products: this.cloneDeep(this.room.products),
          services: this.cloneDeep(this.room.services),
          products_print: this.cloneDeep(this.room.products_print),
          posted_items: this.cloneDeep(this.room.posted_items),
          guests: this.cloneDeep(this.room.guests),
          observation: this.room.observation,
          licensePlate: this.room.licensePlate,
        },
        fields: {
          product: this.product,
          service: this.service,
          qtyProduct: this.qtyProduct,
          qtyService: this.qtyService,
          pdv: this.pdv,
          roomObs: this.roomObs,
          licensePlate: this.licensePlate,
          dialogQty: this.dialogQty,
          dialogQtyService: this.dialogQtyService,
          dialogRemoveQty: this.dialogRemoveQty,
          dialogRemoveQtyService: this.dialogRemoveQtyService,
        },
      }
    },
    restoreState(snapshot) {
      if (!snapshot) return
      this.products = snapshot.products
      this.services = snapshot.services
      this.productsPrint = snapshot.productsPrint
      this.postedItems = snapshot.postedItems
      this.product = snapshot.fields.product
      this.service = snapshot.fields.service
      this.qtyProduct = snapshot.fields.qtyProduct
      this.qtyService = snapshot.fields.qtyService
      this.pdv = snapshot.fields.pdv
      this.roomObs = snapshot.fields.roomObs
      this.licensePlate = snapshot.fields.licensePlate
      this.dialogQty = snapshot.fields.dialogQty
      this.dialogQtyService = snapshot.fields.dialogQtyService
      this.dialogRemoveQty = snapshot.fields.dialogRemoveQty
      this.dialogRemoveQtyService = snapshot.fields.dialogRemoveQtyService
      this.room.products = snapshot.room.products
      this.room.services = snapshot.room.services
      this.room.products_print = snapshot.room.products_print
      this.room.posted_items = snapshot.room.posted_items
      this.room.guests = snapshot.room.guests
      this.guests = snapshot.room.guests
      this.room.observation = snapshot.room.observation
      this.room.licensePlate = snapshot.room.licensePlate
    },
    performProductRemoval(payload, token = null) {
      this.loadingRemovedProduct = true
      this.btnQtyRemoveProduct = true

      payload.room_id = this.room.id
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        request = this.$http.post('manager_room/store_item_removed', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        request = this.storeItemRemoved(payload)
      }

      return request
        .then(response => {
          if (response.data.room) {
            this.room = response.data.room
            this.products = response.data.room.current_accommodation?.product || []
            this.services = response.data.room.current_accommodation?.service || []
            this.guests = response.data.room.current_accommodation?.guest || []
          }

          this.dialogRemoveQty = false
          this.obsRemoveProduct = ''
          this.errorObsRemoveProduct = null

          this.$emit('updategrid')
          this.$toast.success('Produto estornado com sucesso')

          return response
        })
        .catch(error => {
          if (!token && error && error.response && error.response.status === 403) {
            this.queueAuthorization('product', payload)

            return Promise.resolve()
          }

          const msg = error?.response?.data?.error || 'Erro ao estornar produto'
          this.$toast.error(msg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingRemovedProduct = false
          this.btnQtyRemoveProduct = false
        })
    },
    performServiceRemoval(payload, token = null) {
      this.loadingRemovedService = true
      this.btnQtyRemoveService = true

      payload.room_id = this.room.id
      payload = this.addOriginalContext(payload, !!token)

      let request
      if (token) {
        request = this.$http.post('manager_room/store_item_removed', payload, {
          headers: { Authorization: `Bearer ${token}` },
        })
      } else {
        request = this.storeItemRemoved(payload)
      }

      return request
        .then(response => {
          if (response.data.room) {
            this.room = response.data.room
            this.products = response.data.room.current_accommodation?.product || []
            this.services = response.data.room.current_accommodation?.service || []
            this.guests = response.data.room.current_accommodation?.guest || []
          }

          this.dialogRemoveQtyService = false
          this.obsRemoveService = ''
          this.errorObsRemoveService = null

          this.$emit('updategrid')
          this.$toast.success('Serviço estornado com sucesso')

          return response
        })
        .catch(error => {
          if (!token && error && error.response && error.response.status === 403) {
            this.queueAuthorization('service', payload)

            return Promise.resolve()
          }

          const msg = error?.response?.data?.error || 'Erro ao estornar serviço'
          this.$toast.error(msg)

          return Promise.reject(error)
        })
        .finally(() => {
          this.loadingRemovedService = false
          this.btnQtyRemoveService = false
        })
    },
    validEmail() {
      if (this.admLogin.email === '') {
        this.message_error_email = 'Obrigatório'

        return false
      }
      this.message_error_email = ''

      return true
    },
    validPassword() {
      if (this.admLogin.password === '') {
        this.message_error_password = 'Obrigatório'

        return false
      }
      this.message_error_password = ''

      return true
    },
    loadCurrentRole() {
      this.getUser().then(response => {
        if (response.data.role.name == 'Admin') {
          this.admRole.authorization = true
        } else {
          this.admRole.authorization = false
        }
      })
    },

    showExtraDialog() {
      this.accommodation_exta = this.room.current_accommodation.extra_items
      this.dialogExtra = true
    },
    closeExtraDialog() {
      this.dialogExtra = false
    },
    addExtraItem() {
      this.accommodation_exta.push({ value: 0, description: '', type: 'additional' })
    },
    addExtraItemDiscount() {
      this.accommodation_exta.push({ value: 0, description: '', type: 'discount' })
    },
    removeExtraTariff(item) {
      const index = this.accommodation_exta.indexOf(item)
      this.accommodation_exta.splice(index, 1)
    },
    updateExtraTariff() {
      this.accommodation_exta = this.accommodation_exta.map(item => {
        if (item.type == 'additional') {
          return {
            id: item.id,
            value: item.value,
            description: item.description,
            type: item.type,
          }
        }

        return {
          id: item.id,
          value: -Math.abs(item.value),
          description: item.description,
          type: item.type,
        }
      })

      const data = {
        accommodation_id: this.room.current_accommodation.id,
        extra_items: this.accommodation_exta,
      }

      this.updateExtraTarrif(data)
        .then(response => {
          this.$toast.success('Tarifas extras atualizadas com sucesso')
          this.room.current_accommodation.extra_items = response.data
          this.storeCheckout()
          this.closeExtraDialog()
        })
        .catch(error => {
          // CHAVE: Detecta 403 e solicita autorização
          if (error?.response?.status === 403) {
            this.dialogAuthorization = true

            return
          }

          // Erro 422 - validação de negócio (tarifa auditada, etc)
          if (error.response?.status === 422 && error.response?.data?.error) {
            this.$toast.error(error.response.data.error)
            if (error.response.data.message) {
              this.$toast.warning(error.response.data.message)
            }

            return
          }

          this.$toast.error('Erro ao atualizar tarifas extras')
        })
    },
    showOutstanding() {
      this.dialogOutstanding = true
    },
    moveOutstanding() {
      if (this.loadingTransf) return // proteção contra duplo clique

      this.loadingTransf = true

      const payload = {
        room_category_id: this.room.room_category_id,
        room_id: this.room.id,
        description: this.room.description,
        status: 'open',
        prop: this.room.prop,
        current_accommodation_id: this.room.current_accommodation.id,
        current_reserve_id: this.room.current_reserve_id,
        status_time: new Date(),
      }

      this.storeOutstanding(payload).then(response => {
        this.dialogTranfRoom = false
        this.roomId = ''
        this.$emit('updategrid')
        this.$emit('close')
        this.$toast.success('Transferido com sucesso')
      })
        .finally(() => {
          this.loadingTransf = false
        })
    },
    showCancelDialog() {
      this.dialogCancel = true
    },
    sendCancelChekin() {
      // valida a justificativa
      if (this.cancelInput == '') {
        this.errorCancelInput = 'Campo Obrigatório'

        return false
      }
      this.loadingTransf = true

      const payload = {
        accommodation_id: this.room.current_accommodation.id,
        observation: this.cancelInput,
      }

      this.cancelCheckin(payload)
        .then(response => {
          this.dialogCancel = false
          this.roomId = ''
          this.$emit('updategrid')
          this.$emit('close')
          this.$toast.success('Checkin cancelado com sucesso')
        })
        .finally(() => {
          this.loadingTransf = false
        })
    },

  },
}
</script>

<style scoped>
.custom-title {
  color: #FF4C51;
}

.hide-print-orders {
  display: none !important;
}
</style>
    hasPrinters: false,
